import React, { useState } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import GdprInfo from "./components/GdprInfo";

import { useRef } from "react";
import { IMaskInput } from "react-imask";
import Input from "./components/Input";
import Label from "./components/Label";
import Select from "./components/Select";
import * as Const from "./_Const";
import NotFoundSection from "./components/NotFoundSection";
import Navbar from "./components/Navbar";
import useMediaQuery from "./hooks/useMediaQuery";

const insurance = [
  {
    value: "0",
    label: "Vyberte pojišťovnu",
  },
  {
    value: "111",
    label: "111 - Všeobecná zdravotní pojišťovna ČR",
  },
  {
    value: "201",
    label: "201 - Vojenská zdravotní pojišťovna ČR",
  },
  {
    value: "205",
    label: "205 - Česká průmyslová zdravotní pojišťovna",
  },
  {
    value: "207",
    label: "207 - Oborová zdravotní pojišťovna zaměstnanců bank, pojišťoven a stavebnictví",
  },
  {
    value: "209",
    label: "209 - Zaměstnanecká pojišťovna ŠKODA",
  },
  {
    value: "211",
    label: "211 - Zdravotní pojišťovna Ministerstva vnitra ČR",
  },
  {
    value: "213",
    label: "213 - Revírní bratrská pokladna, zdravotní pojišťovna",
  },
  {
    value: "300",
    label: "300 - samoplátce",
  },
];

function PagePersonalInfo({ onNext, onPrev }) {
  //sconst [value, setValue] = useState(0);
  const { getPageData, handleInput, state, setCurrentStepIndex, isEmptyState } = useFormCtx();
  const index = Const.REG_02_INDEX;
  const page = getPageData(index);

  const notFound = isEmptyState();

  const isRpiScreen = useMediaQuery("(min-width: 1200px)");
  const textClass = isRpiScreen ? "text-4xl h-20" : "h-10";

  //potrebuju mit vybranou 0 - Vyberte pojišťovnu kdyz je prazdna pojistovna
  const insuranceValue = state.insurance === "" ? "0" : state.insurance;

  // use ref to get access to internal "masked = ref.current.maskRef"
  const ref = useRef(null);
  const inputRef = useRef(null);
  const errorClass = state.errors.personalNumber ? "border-error-dark" : "border-accent";
  return (
    <>
      {!notFound && (
        <PageWrapper title={page.title} index={index}>
          <h2 className="mt-6 text-xl font-light text-primary mx-6">{page.subtitle}</h2>
          <div className="mt-4 flex flex-col space-y-4 mx-6">
            <div className="flex flex-col">
              <label htmlFor="personalNumber" className="text-primary"></label>
              <Label label={"Rodné číslo"} name={"personalNumber"} errorMessage={state.errors.personalNumber} />
              <IMaskInput
                mask={"0000000000"}
                maxLength={10}
                value={state.personalNumber}
                onChange={(e) => handleInput(e)}
                unmask={true} // true|false|'typed'
                ref={ref}
                inputRef={inputRef}
                /*onAccept={(value, mask) => console.log(value)}*/
                name="personalNumber"
                id="personalNumber"
                placeholder="Vyplňte rodné číslo bez lomítka"
                autoComplete="off"
                className={`border rounded-xl ${textClass} p-4 inset-shadow-xl bg-white focus:outline-none  selection:bg-accent-secondary selection:text-black  ${errorClass}`}
              />
            </div>
            <Input
              label="Příjmení"
              name="lastName"
              value={state.lastName}
              errorMessage={state.errors.lastName}
              autoComplete="family-name"
              onChange={(e) => handleInput(e)}
            />
            <Input
              label="Jméno"
              name="firstName"
              value={state.firstName}
              errorMessage={state.errors.firstName}
              autoComplete="given-name"
              onChange={(e) => handleInput(e)}
            />

            <Select
              label="Pojišťovna"
              data={insurance}
              name="insurance"
              defaultValue="0"
              value={insuranceValue}
              errorMessage={state.errors.insurance}
              onChange={(e) => handleInput(e)}
            />

            {/* <Input
          label="E-mail"
          name="email"
          value={state.email}
          errorMessage={state.errors.email}
          autoComplete="email"
          onChange={(e) => handleInput(e)}
          type="email"
        /> */}
          </div>
          {/* <p className="mx-6 mt-4 text-sm text-secondary font-light">E-mail vyplňte pouze v případě, že chcete obdržet potvrzení o registraci do systému.</p> */}
          <div className="mt-8">
            <GdprInfo />
          </div>
        </PageWrapper>
      )}
      {notFound && (
        <>
          <Navbar />
          <NotFoundSection
            className="mx-6"
            title={"Stránka nenalezena"}
            subtitle={"Stránka již není aktivní. Pokračujte prosím stisknutím tlačítka"}
            action="Na hlavní obrazovku"
            showButton={true}
          />
        </>
      )}
    </>
  );
}

export default PagePersonalInfo;
